import * as actionType from "./maintenanceDashboardAction";
import { ApiGateWay } from "../../../ApiGateWay/ApiGateWay";
import { Config } from "../../../config/config";
import Cookie from "js-cookie";

const config = JSON.parse(Config);
export const monthNames = config["month"];

const initialState = {
  message: "",
  modalOpen: false,
  loading: false,
  apiStatus: false,
};

// export const SetDashboardScore = (data) => ({
//   type: actionType.SET_DASHBOARD_SCORE,
//   payload: data,
// });
// apiCallStatus is also used as above i.e SetDashboardScore
export const apiCallStatus = (data) => ({
  type: actionType.API_CALL_STATUS,
  payload: data,
});

export const GetTpvChartData = (data) => ({
  type: actionType.GET_TPV_CHART_DATA,
  payload: data,
});
export const GetTpvModalData = (data) => ({
  type: actionType.GET_TPV_MODAL_DATA,
  payload: data,
});
export const GetIncidentChartData = (data) => ({
  type: actionType.GET_INCIDENT_CHART_DATA,
  payload: data,
});
export const GetIncidentModalData = (data) => ({
  type: actionType.GET_INCIDENT_MODAL_DATA,
  payload: data,
});
export const GetIncidentCodes = (data) => ({
  type: actionType.INCIDENT_CODE,
  payload: data,
});
export const GetPmpChartData = (data) => ({
  type: actionType.GET_PREVENTIVE_CHART_DATA,
  payload: data,
});
export const GetPmpModalData = (data) => ({
  type: actionType.GET_PREVENTIVE_MODAL_DATA,
  payload: data,
});
export const GetWorkRequestChartData = (data) => ({
  type: actionType.GET_WORK_REQUEST_CHART_DATA,
  payload: data,
});
export const GetWorkRequestModalData = (data) => ({
  type: actionType.GET_WORK_REQUEST_MODAL_DATA,
  payload: data,
});
export const GetStoreList = (data) => ({
  type: actionType.STORE_LIST,
  payload: data,
});

export const SetPreventiveData = ({
  preventiveMaintenanceData,
  pmpYtdTotal,
}) => ({
  type: actionType.PREVENTIVE_MAINTENANCE_DATA,
  payload: {
    preventiveMaintenanceData,
    pmpYtdTotal,
  },
});
export const SetTpvData = ({ tpvData }) => ({
  type: actionType.THIRD_PARTY_AUDIT_DATA,
  payload: {
    tpvData,
  },
});
export const SetIncidentData = ({ incidentBarData, incidenDoughnutData }) => ({
  type: actionType.MAINTENANCE_INCIDENT_DATA,
  payload: {
    incidentBarData,
    incidenDoughnutData,
  },
});
export const SetWorkRequestData = ({ workRequestData, requestYdtTotal }) => ({
  type: actionType.WORK_REQUEST_DATA,
  payload: {
    workRequestData,
    requestYdtTotal,
  },
});
export const GetAssetHealthWeightage = (data) => ({
  type: actionType.ASSET_HEALTH_WEIGHT,
  payload: data,
});
export const fetchAssetHealthWeightage = () => async (dispatch) => {
  return ApiGateWay.SimpleGet(config["api2"] + "/api/assetHealthScoreWeightage")
    .then((response) => {
      initialState.loading = false;
      if (response.status == "Success") {
        initialState.message = "";
        initialState.modalOpen = false;
        initialState.apiStatus = false;

        const { masterQuickCodesInfo } = response;
        if (!masterQuickCodesInfo) {
          const weights = {
            IncidentWeight: 0,
            PreventiveWeight: 0,
            TpvWeight: 0,
            WorkRequestWeight: 0,
          };
          initialState.loading = false;
          initialState.modalOpen = true;
          initialState.message = "Failed to fetch asset health weights";
          dispatch(
            GetAssetHealthWeightage({
              weights: weights,
            })
          );
          dispatch(apiCallStatus(initialState));
        }
        const result = masterQuickCodesInfo.reduce((acc, code) => {
          acc[code.codeType] = parseInt(code.codeValue);
          return acc;
        }, {});
        dispatch(
          GetAssetHealthWeightage({
            weights: result,
          })
        );

        dispatch(apiCallStatus(initialState));
      } else {
        initialState.message = response?.errorMessage;
        initialState.modalOpen = true;
        dispatch(apiCallStatus(initialState));
      }
    })
    .catch((e) => handleError(e, dispatch));
};

const fetchData = async (dispatch, url, payload, chartAction, modalAction) => {
  try {
    const response = await ApiGateWay.SimplePost(url, payload);
    initialState.loading = false;

    if (response.status === "Success") {
      initialState.message = "";
      initialState.modalOpen = false;
      initialState.apiStatus = false;

      if (!payload.alertType) {
        dispatch(chartAction(response));
      } else {
        dispatch(modalAction(response));
      }

      dispatch(apiCallStatus(initialState));
    } else {
      initialState.message = response.errorMessage;
      initialState.modalOpen = true;
      dispatch(apiCallStatus(initialState));
    }
  } catch (error) {
    handleError(error, dispatch);
  }
};

export const fetchTpvData = (
  alertType = "",
  alertLevel = "",
  storeId = "",
  month = "",
  year = ""
) => {
  const payload = { alertType, alertLevel, storeId, month, year };
  return (dispatch) => {
    fetchData(
      dispatch,
      config["api2"] + "/api/getTpvData",
      payload,
      (response) => {
        const { ncTotal, tpvNCInfo } = response;
        return GetTpvChartData({
          totalCount: ncTotal,
          tpvChartData: tpvNCInfo,
        });
      },
      (response) => GetTpvModalData({ tpvModalData: response.tpvNcViewList })
    );
  };
};

export const fetchIncidentData = (
  alertType = "",
  alertLevel = "",
  storeId = "",
  month = "",
  year = ""
) => {
  const payload = { alertType, alertLevel, storeId, month, year };
  return (dispatch) => {
    fetchData(
      dispatch,
      config["api2"] + "/api/getIncidentData",
      payload,
      (response) => {
        const { incidentTotal, incidentInfo } = response;
        return GetIncidentChartData({
          totalCount: incidentTotal,
          incidentChartData: incidentInfo,
        });
      },
      (response) =>
        GetIncidentModalData({
          incidentModalData: response.conditionalWebGrids,
        })
    );
  };
};

export const fetchPmpData = (
  alertType = "",
  alertLevel = "",
  storeId = "",
  month = "",
  year = ""
) => {
  const payload = { alertType, alertLevel, storeId, month, year };
  return (dispatch) => {
    fetchData(
      dispatch,
      config["api2"] + "/api/getPreventiveChartNModelData",
      payload,
      (response) => {
        const { pmpChartInfo, StarDate, EndDate, YTD } = response;
        return GetPmpChartData({
          PmpChartData: pmpChartInfo,
          PmpStartDate: StarDate,
          PmpEndDate: EndDate,
          PmpYtdData: YTD,
        });
      },
      (response) =>
        GetPmpModalData({ PmpModalData: response.conditionalWebGrids })
    );
  };
};

export const fetchWorkRequestData = (
  alertType = "",
  alertLevel = "",
  storeId = "",
  month = "",
  year = ""
) => {
  const payload = { alertType, alertLevel, storeId, month, year };
  return (dispatch) => {
    fetchData(
      dispatch,
      config["api2"] + "/api/getWorkRequestData",
      payload,
      (response) => {
        const { workRequestChartInfo, YTD } = response;
        return GetWorkRequestChartData({
          WorkRequestChartData: workRequestChartInfo,
          WorkRequestYtdData: YTD,
        });
      },
      (response) =>
        GetWorkRequestModalData({
          WorkEquestModalData: response.workRequestData,
        })
    );
  };
};

export const fetchStoreList = (payload) => async (dispatch) => {
  initialState.loading = true;
  dispatch(apiCallStatus(initialState));
  return ApiGateWay.Post(config["api"] + "/fetchStoreInfo", payload)
    .then((response) => response.json())
    .then((response) => {
      initialState.loading = false;
      if (
        response.errorMessage === "Token Expired" ||
        response.errorMessage === "Invalid Token:::JWT expired" ||
        response.errorMessage ===
          "Your session has expired. Please login again."
      ) {
        Cookie.remove("currentUser");
        Cookie.remove("stores");
        Cookie.remove("storesAll");
        Cookie.remove("warehouses");
        localStorage.clear();
        sessionStorage.clear();
        initialState.message =
          "Your session has been expired and you will be redirected to the login page!!";
        initialState.modalOpen = true;
        initialState.apiStatus = false;
        setTimeout(() => {
          window.location = "/";
        }, 4000);
      }

      if (response["storesInfos"][0]["storeType"] === "Store") {
        //sort
        response["storesInfos"][0]["storeLocationsInfos"].sort((a, b) =>
          a.storeName > b.storeName ? 1 : -1
        );
        dispatch(
          GetStoreList({
            storeList: response["storesInfos"][0]["storeLocationsInfos"],
          })
        );
      } else {
        //sort
        response["storesInfos"][0]["storeLocationsInfos"].sort((a, b) =>
          a.storeName > b.storeName ? 1 : -1
        );
        dispatch(
          GetStoreList({
            storeList: response["storesInfos"][1]["storeLocationsInfos"],
          })
        );
        initialState.message = "";
        initialState.modalOpen = false;
        initialState.apiStatus = false;
      }
      dispatch(apiCallStatus(initialState));
    })
    .catch((e) => handleError(e, dispatch));
};

export const fetchIncidentCodes = () => async (dispatch) => {
  initialState.loading = true;
  dispatch(apiCallStatus(initialState));
  return ApiGateWay.Get(config["api"] + "/fetchIncidentCodes")
    .then((response) => response.json())
    .then((response) => {
      initialState.loading = false;
      if (
        response.errorMessage === "Token Expired" ||
        response.errorMessage === "Invalid Token:::JWT expired" ||
        response.errorMessage ===
          "Your session has expired. Please login again."
      ) {
        Cookie.remove("currentUser");
        Cookie.remove("stores");
        Cookie.remove("storesAll");
        Cookie.remove("warehouses");
        localStorage.clear();
        sessionStorage.clear();
        initialState.message =
          "Your session has been expired and you will be redirected to the login page!!";
        initialState.modalOpen = true;
        initialState.apiStatus = false;
        setTimeout(() => {
          window.location = "/";
        }, 4000);
      }
      let codeMap = [];
      if (response?.staticCodes) {
        codeMap = response?.staticCodes.filter((code) => {
          return code?.codeType === "Incident Level";
        });
      }
      initialState.message = "";
      initialState.modalOpen = false;
      initialState.apiStatus = false;
      if (codeMap.length)
        dispatch(
          GetIncidentCodes({
            incidentCodes: codeMap,
          })
        );
      dispatch(apiCallStatus(initialState));
    })
    .catch((e) => handleError(e, dispatch));
};

export function getQuarterMonths(startDate, endDate) {
  startDate = new Date(startDate);
  endDate = new Date(endDate);

  const startMonth = startDate.getMonth();
  const endMonth = endDate.getMonth();

  const startYear = startDate.getFullYear();
  const endYear = endDate.getFullYear();
  let startQuarter = Math.floor(startMonth / 3) + 1;

  let quarter = "";
  if (startYear === endYear) {
    return `${startYear} Q${startQuarter}`;
  } else if (startYear !== endYear) {
    if (startMonth === 9 && endMonth === 2) {
      quarter = `Q4 ${startYear}, Q1 ${endYear}`;
    } else if (startMonth === 9 && endMonth === 5) {
      quarter = `Q4 ${startYear}, Q1, Q2 ${endYear}`;
    } else if (startMonth === 9 && endMonth === 8) {
      quarter = `Q4 ${startYear}, Q1, Q2, Q3 ${endYear}`;
    }
  }

  return quarter;
}

export function getQuarterRange(quarter, startDate, endDate) {
  startDate = new Date(startDate);
  endDate = new Date(endDate);
  const startYear = startDate.getFullYear();
  const endYear = endDate.getFullYear();
  let dateRange;

  switch (quarter) {
    case `${startYear} Q1`:
      dateRange = endYear;
      break;
    case `${startYear} Q2`:
      dateRange = endYear;
      break;
    case `${startYear} Q3`:
      dateRange = endYear;
      break;
    case `${startYear} Q4`:
      dateRange = endYear + 1;
      break;
    case `Q4 ${startYear}, Q1 ${endYear}`:
      dateRange = `${startYear} - ${endYear}`;
      break;
    case `Q4 ${startYear}, Q1, Q2 ${endYear}`:
      dateRange = `${startYear} - ${endYear}`;
      break;
    default:
      dateRange = `${startYear} - ${endYear}`;
  }

  return dateRange;
}
export function getCurrentYear(startDate, endDate) {
  const startYear = new Date(startDate).getFullYear();
  const endYear = new Date(endDate).getFullYear();

  if (startYear === endYear) {
    return String(startYear);
  } else {
    return `${startYear} - ${endYear}`;
  }
}
export function getMonthData(year, month) {
  if (year === "" && month === "") {
    return monthNames[new Date().getMonth()];
  } else if (year !== "" && month === "") {
    return "January - December";
  } else if (year === "" && month !== "") {
    return monthNames[parseInt(month, 10) - 1];
  } else {
    return monthNames[parseInt(month, 10) - 1];
  }
}

function handleError(e, dispatch) {
  initialState.message = "Something went wrong please try again after sometime";
  initialState.modalOpen = true;
  initialState.apiStatus = false;
  initialState.loading = false;
  console.log("Error: ", e);
  dispatch(apiCallStatus(initialState));
}
